module.exports = __webpack_public_path__ + "static/media/hamburger.4422db8f.svg";